<template lang="pug">
div(class="subscriptions-management scrollable-tab")
    div(class="header-row")
        div
            //- h2 Subscription Management
            //- p Create and manage subscription packages 
        button(class="create-btn" @click="showModal = true") + {{ activeTab === 'paid' ? 'Create Subscription' : 'Create Acknowledgment' }}
    
    // Tab Navigation
    div(class="tab-navigation")
        div(class="tab-buttons")
            button(class="tab-btn" :class="{ active: activeTab === 'paid' }" @click="switchTab('paid')")
                span  Subscriptions
                span(class="count" v-if="paidCount > 0") {{ paidCount }}
            button(class="tab-btn" :class="{ active: activeTab === 'free' }" @click="switchTab('free')")
                span  Acknowledgments
                span(class="count" v-if="freeCount > 0") {{ freeCount }}
    
    div(class="card")
        //- p(v-if="loading") Loading subscriptions and acknowledgments...
        div(class="table-container")
            table(class="packages-table")
                thead
                    tr
                        th {{ activeTab === 'paid' ? 'Package Name' : 'Acknowledgment Name' }}
                        th(v-if="activeTab === 'paid'") Price
                        th Start Date
                        th End Date
                        //- th Recurring
                        th Actions
                tbody
                tr(v-if="loading")
                    td(:colspan="activeTab === 'paid' ? 6 : 5" class="loading-cell")
                        div(class="spinner-container")
                            b-spinner(variant="primary" label="Loading...")
                            p Loading...
                tr(v-else-if="error")
                    td(:colspan="activeTab === 'paid' ? 6 : 5" class="error-cell")
                        div(class="error-container")
                            b-icon(icon="exclamation-triangle" size="24")
                            p {{ error }}
                            button(class="retry-btn" @click="fetchPackages")
                                b-icon(icon="arrow-clockwise" size="16")
                                | Retry
                tr(v-else-if="packages?.length === 0")
                    td(:colspan="activeTab === 'paid' ? 6 : 5" class="empty-cell")
                        div(class="empty-container")
                            b-icon(icon="inbox" size="32")
                            p No {{ activeTab === 'paid' ? 'subscription packages' : 'acknowledgments' }} found.
                
                tr(v-for="pkg in packages" :key="pkg?.crb5c_subscriptionsid" class="subscription-row" @click="viewSubscribers(pkg)")
                    td(class="package-info")
                        div(class="package-title") {{ pkg.crb5c_title }}
                        div(class="package-desc" v-html="pkg.crb5c_description") 
                    td(v-if="activeTab === 'paid'" class="price-cell") 
                        div(class="price-total") ${{ calculateTotalWithGST(pkg) }}
                        div(class="price-breakdown" v-if="pkg.crb5c_gst > 0") (incl. {{ pkg.crb5c_gst }}% GST)
                    td(class="date-cell") {{ formatDate(pkg.crb5c_datefrom) }}
                    td(class="date-cell") {{ formatDate(pkg.crb5c_datetill) }}
                    //- td(class="status-cell")
                    //-     span(class="status-badge" :class="pkg.crb5c_recurring ? 'recurring' : 'one-time'") 
                    //-         | {{ pkg.crb5c_recurring ? 'Recurring' : 'One-time' }}
                    td(class="actions" @click.stop)
                        button(class="action-btn download" @click="exportSubscriptionExcel(pkg)" title="Export Excel")
                            b-icon(icon="download" size="16") 
                        button(class="action-btn edit" @click="editPackage(pkg)" title="Edit")
                            b-icon(icon="pencil" size="16")
                        button(class="action-btn delete" @click="confirmDelete(pkg)" title="Delete")
                            b-icon(icon="trash" size="16")
        
        div(class="pagination-section" v-if="hasMoreData || loadingMore")
            button(class="load-more-btn" @click="loadMorePackages" :disabled="loadingMore")
                b-spinner(small v-if="loadingMore")
                b-icon(icon="plus-circle" size="16" v-else)
                span(v-if="loadingMore") Loading more...
                span(v-else) Load More ({{ totalCount - packages.length }} remaining)
    
    CreateSubscriptionModal(:showModal="showModal" @update:showModal="showModal = $event" @create="addPackage" :groups="groups" :isAcknowledgment="activeTab === 'free'")
    EditSubscriptionModal(v-if="selectedSubscription" :showModal="showEditModal" :subscription="selectedSubscription" @update:showModal="showEditModal = $event" @edit="handleEdit" :isAcknowledgment="selectedSubscription && selectedSubscription.crb5c_amount === 0" :groups="groups" :clients="clients")
    b-modal(v-model="showDeleteModal" title="Delete Subscription" @ok="deleteSubscription" @cancel="cancelDelete" ok-title="Delete" cancel-title="Cancel" ok-variant="danger")
        p Are you sure you want to delete the subscription package?
        p
            strong {{ deleteTarget?.crb5c_title }}
</template>

<script>
import CreateSubscriptionModal from './CreateSubscriptionModal.vue';
import EditSubscriptionModal from './EditSubscriptionModal.vue';
import axios from 'axios';
import {  mapActions } from 'vuex';

export default {
    components: {
        CreateSubscriptionModal,
        EditSubscriptionModal
    },
    data() {
        return {
            showModal: false,
            showEditModal: false,
            selectedSubscription: null,
            showDeleteModal: false,
            deleteTarget: null,
            activeTab: 'paid', 
            groups: [],
            clients: [],
            sendIcon: '',
            editIcon: '',
            deleteIcon: '',
            loading: false,
            loadingMore: false,
            error: '',
          
            paidData: {
                packages: [],
                nextPageLink: null,
                totalCount: 0,
                hasMoreData: false
            },
            freeData: {
                packages: [],
                nextPageLink: null,
                totalCount: 0,
                hasMoreData: false
            }
        }
    },
    computed: {
        packages() {
            return this.activeTab === 'paid' ? this.paidData.packages : this.freeData.packages;
        },
        nextPageLink() {
            return this.activeTab === 'paid' ? this.paidData.nextPageLink : this.freeData.nextPageLink;
        },
        totalCount() {
            return this.activeTab === 'paid' ? this.paidData.totalCount : this.freeData.totalCount;
        },
        hasMoreData() {
            return this.activeTab === 'paid' ? this.paidData.hasMoreData : this.freeData.hasMoreData;
        },
        paidCount() {
            return this.paidData.totalCount;
        },
        freeCount() {
            return this.freeData.totalCount;
        }
    },
    async mounted() {
        await this.fetchBothCategories();
        await this.getClientsData();
        const { sessions } = await this.getEveryGroup();
        if (!sessions || sessions.length === 0) {
                return;
            }

            const sessionMap = sessions.map(item => ({
                id: item.crb5c_fow_session_scheduleid,
                name: item.crb5c_session_id,
                day: item.crb5c_day,
            }));
        let sortListGroupSession = this.$root.sortSessionGroupNameByDay(sessionMap);
            sortListGroupSession.unshift({ id: 'All', name: 'All' });


            this.groups = sortListGroupSession;
    },
    methods: {
        ...mapActions(['getEveryGroup']),
        formatDate(dateStr, locale = 'en-gb') {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            // return d.toLocaleDateString(locale) + ' ' + d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
            return d.toLocaleDateString(locale) 
        },
        calculateTotalWithGST(pkg) {
            const baseAmount = parseFloat(pkg.crb5c_amount || 0);
            const gstPercentage = parseFloat(pkg.crb5c_gst || 0);
            const gstAmount = baseAmount * gstPercentage / 100;
            const total = baseAmount + gstAmount;
            return total.toFixed(2);
        },
        async getClientsData() {
            try {
                const clientsData = this.$root.cli_list || [];
                this.clients = clientsData.map(client => ({
                    id: client.crb5c_fow_customerid,
                    name: client.crb5c_no
                }));
            } catch (error) {
                console.error('Error getting clients data:', error);
            }
        },
        async fetchBothCategories() {
            this.loading = true;
            this.error = '';
            try {
                
                const [paidResponse, freeResponse] = await Promise.all([
                    axios.get('/api/subscription', { params: { category: 'paid' } }),
                    axios.get('/api/subscription', { params: { category: 'free' } })
                ]);
                
                console.log('Paid packages response:', paidResponse.data);
                console.log('Free packages response:', freeResponse.data);
                
                
                this.paidData.packages = paidResponse.data.data || [];
                this.paidData.nextPageLink = paidResponse.data.nextPageLink;
                this.paidData.totalCount = paidResponse.data.count || 0;
                this.paidData.hasMoreData = !!paidResponse.data.nextPageLink;
                
                
                this.freeData.packages = freeResponse.data.data || [];
                this.freeData.nextPageLink = freeResponse.data.nextPageLink;
                this.freeData.totalCount = freeResponse.data.count || 0;
                this.freeData.hasMoreData = !!freeResponse.data.nextPageLink;
                console.log(this.freeData.packages)
                
            } catch (err) {
                console.error('Error fetching packages:', err);
                this.error = err?.response?.data?.message || 'Failed to fetch subscriptions';
            } finally {
                this.loading = false;
            }
        },
        async fetchPackages(category = null) {
            const targetCategory = category || this.activeTab;
            this.loading = true;
            this.error = '';
            try {
                
                const res = await axios.get('/api/subscription', {
                    params: { category: targetCategory }
                });
                console.log('Fetch packages response:', res.data);
                
                
                const packages = res.data.data || [];
                
                
                if (targetCategory === 'paid') {
                    this.paidData.packages = packages;
                    this.paidData.nextPageLink = res.data.nextPageLink;
                    this.paidData.totalCount = res.data.count || packages.length;
                    this.paidData.hasMoreData = !!res.data.nextPageLink;
                } else {
                    this.freeData.packages = packages;
                    this.freeData.nextPageLink = res.data.nextPageLink;
                    this.freeData.totalCount = res.data.count || packages.length;
                    this.freeData.hasMoreData = !!res.data.nextPageLink;
                }
            } catch (err) {
                console.error('Error fetching packages:', err);
                this.error = err?.response?.data?.message || 'Failed to fetch subscriptions';
            } finally {
                this.loading = false;
            }
        },
        async loadMorePackages() {
            if (!this.nextPageLink || this.loadingMore) return;
            
            this.loadingMore = true;
            try {
                console.log('Loading more with nextPageLink:', this.nextPageLink);
                
                const res = await axios.post('/api/subscription', {
                    nextPageLink: this.nextPageLink
                }, {
                    params: { category: this.activeTab }
                });
                
                console.log('Load more response:', res.data);
                const newPackages = res.data.data || [];
                
                
                if (this.activeTab === 'paid') {
                    this.paidData.packages = [...this.paidData.packages, ...newPackages];
                    this.paidData.nextPageLink = res.data.nextPageLink;
                    this.paidData.hasMoreData = !!res.data.nextPageLink;
                } else {
                    this.freeData.packages = [...this.freeData.packages, ...newPackages];
                    this.freeData.nextPageLink = res.data.nextPageLink;
                    this.freeData.hasMoreData = !!res.data.nextPageLink;
                }
            } catch (err) {
                console.error('Error loading more packages:', err);
                console.error('Error response:', err.response);
                this.$bvToast.toast(`Failed to load more subscriptions: ${err.response?.data?.message || err.message}`, {
                    title: 'Load Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.loadingMore = false;
            }
        },
        switchTab(tab) {
            this.activeTab = tab;
            
            if (tab === 'paid' && this.paidData.packages.length === 0 && this.paidData.totalCount === 0) {
                this.fetchPackages('paid');
            } else if (tab === 'free' && this.freeData.packages.length === 0 && this.freeData.totalCount === 0) {
                this.fetchPackages('free');
            }
        },
        /* eslint-disable no-unused-vars */
        addPackage(pkg) {
            
            this.fetchBothCategories();
        },
        editPackage(pkg) {
            this.selectedSubscription = pkg;
            this.showEditModal = true;
        },
        handleEdit(updated) {
            
            this.fetchBothCategories();
        },
        confirmDelete(pkg) {
            this.deleteTarget = pkg;
            this.showDeleteModal = true;
        },
        async deleteSubscription() {
            if (!this.deleteTarget) return;
            try {
                await axios.delete(`/api/subscription/${this.deleteTarget.crb5c_subscriptionsid}`);
                
                this.fetchBothCategories();
            } catch (err) {
                this.error = err?.response?.data?.message || 'Failed to delete subscription';
            } finally {
                this.showDeleteModal = false;
                this.deleteTarget = null;
            }
        },
        cancelDelete() {
            this.showDeleteModal = false;
            this.deleteTarget = null;
        },
        exportData() {

            const dataStr = JSON.stringify(this.packages, null, 2);
            const blob = new Blob([dataStr], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'subscription_packages.json';
            a.click();
            URL.revokeObjectURL(url);
        },
        async exportSubscriptionExcel(pkg) {
            try {
                const response = await axios.get(`/api/subscription/${pkg.crb5c_subscriptionsid}/subscribers/export`, {
                    responseType: 'blob'
                });
                
                
                const blob = new Blob([response.data], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                
                
                const contentDisposition = response.headers['content-disposition'];
                let fileName = `${pkg.crb5c_title}_subscribers.xlsx`;
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/); 
                    if (fileNameMatch) {
                        fileName = fileNameMatch[1];
                    }
                }
                
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                
                this.$bvToast.toast('Excel file downloaded successfully', {
                    title: 'Export Complete',
                    variant: 'success',
                    solid: true
                });
            } catch (err) {
                console.error('Error exporting Excel:', err);
                this.$bvToast.toast('Failed to export Excel file', {
                    title: 'Export Error',
                    variant: 'danger',
                    solid: true
                });
            }
        },
        viewSubscribers(pkg) {
            this.$router.push({
                name: 'SubscriptionDetails',
                params: { subscriptionId: pkg.crb5c_subscriptionsid }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.subscriptions-management {
   
    height: calc(100vh - 48px);
    background: #f8f9fa;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    .tab-navigation {
        margin: 0 16px 24px 16px;
        
        .tab-buttons {
            display: flex;
            gap: 4px;
            border-radius: 12px;
            background: #f1f5f9;
            padding: 4px;
            
            .tab-btn {
                flex: 1;
                background: transparent;
                border: none;
                padding: 12px 20px;
                border-radius: 8px;
                font-size: 0.95rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                color: #64748b;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                
                .count {
                    background: #e2e8f0;
                    color: #475569;
                    border-radius: 12px;
                    padding: 2px 8px;
                    font-size: 0.75rem;
                    font-weight: 600;
                    min-width: 20px;
                    text-align: center;
                }
                
                &.active {
                    background: #fff;
                    color: #374151;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    
                    .count {
                        background: #374151;
                        color: #fff;
                    }
                }
                
                &:hover:not(.active) {
                    background: rgba(255, 255, 255, 0.7);
                    color: #374151;
                }
            }
        }
    }
    
    .header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0;
        h2 {
            font-size: 2rem;
            font-weight: 700;
            margin-bottom: 4px;
            color: #374151;
        }
        p {
            color: #6b7280;
            margin-top: 0;
        }
        .create-btn {
            background: #374151;
            color: #fff;
            border: none;
            border-radius: 12px;
            padding: 12px 24px;
            font-size: 0.95rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            
            &:hover {
                background: #1f2937;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
        }
    }
    
    .card {
        background: #fff;
        border-radius: 20px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

        margin: 0 16px;
        backdrop-filter: blur(10px);
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        
        h3 {
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 8px;
            color: #1e293b;
        }
        
        p {
            color: #64748b;
            margin-bottom: 32px;
            font-size: 1rem;
        }
        
        .table-container {
            flex: 1;
            overflow-y: auto;
            border-radius: 16px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            min-height: 0;
            
            &::-webkit-scrollbar {
                width: 8px;
            }
            
            &::-webkit-scrollbar-track {
                background: #f1f5f9;
            }
            
            &::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
                
                &:hover {
                    background: #94a3b8;
                }
            }
        }
        
        .packages-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            border-radius: 0;
            overflow: visible;
            
            th {
                background: #f1f5f9;
                color: #475569;
                font-weight: 600;
                padding: 8px 12px;
                text-align: left;
                font-size: 0.75rem;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                border-bottom: 2px solid #e2e8f0;
                position: sticky;
                top: 0;
                z-index: 10;
                
                &:first-child {
                    border-top-left-radius: 16px;
                }
                &:last-child {
                    border-top-right-radius: 16px;
                }
            }
            
            .subscription-row {
                cursor: pointer;
                transition: all 0.3s ease;
                background: #fff;
                
                &:hover {
                    background: #f1f5f9;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }
                
                &:nth-child(even) {
                    background: #fafafa;
                    
                    &:hover {
                        background: #f1f5f9;
                    }
                }
                
                td {
                    padding: 10px 12px;
                    border-bottom: 1px solid #e2e8f0;
                    vertical-align: middle;
                    text-align: left;
                }
                
                &:last-child td {
                    border-bottom: none;
                }
            }
            
            .package-info {
                .package-title {
                    font-weight: 600;
                    color: #1e293b;
                    font-size: 0.875rem;
                    margin-bottom: 2px;
                    text-align: left;
                }
                
                .package-desc {
                    color: #64748b;
                    font-size: 0.75rem;
                    line-height: 1.3;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 300px;
                }
            }
            
            .price-cell {
                font-weight: 700;
                color: #059669;
                font-size: 0.875rem;
                
                .price-total {
                    font-size: 0.875rem;
                    font-weight: 700;
                }
                
                .price-breakdown {
                    font-size: 0.65rem;
                    color: #64748b;
                    font-weight: 500;
                    margin-top: 2px;
                }
            }
            
            .date-cell {
                color: #475569;
                font-size: 0.75rem;
            }
            
            .status-cell {
                .status-badge {
                    display: inline-flex;
                    align-items: center;
                    padding: 4px 8px;
                    border-radius: 20px;
                    font-size: 0.65rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    
                    &.recurring {
                        background: #10b981;
                        color: #fff;
                    }
                    
                    &.one-time {
                        background: #f59e0b;
                        color: #fff;
                    }
                }
            }
            
            .actions {
                display: flex;
                gap: 8px;
                align-items: center;
                justify-content: flex-end;
                
                .action-btn {
                    width: 32px;
                    height: 32px;
                    border: none;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &.download {
                        background: #6366f1;
                        color: #fff;
                        
                        &:hover {
                            background: #4f46e5;
                            transform: scale(1.1);
                        }
                    }
                    
                    &.edit {
                        background: #f59e0b;
                        color: #fff;
                        
                        &:hover {
                            background: #d97706;
                            transform: scale(1.1);
                        }
                    }
                    
                    &.delete {
                        background: #ef4444;
                        color: #fff;
                        
                        &:hover {
                            background: #dc2626;
                            transform: scale(1.1);
                        }
                    }
                }
            }
            
            
            .loading-cell, .error-cell, .empty-cell {
                text-align: center;
                padding: 60px 24px;
                
                .spinner-container, .error-container, .empty-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;
                    
                    p {
                        color: #64748b;
                        font-size: 1rem;
                        margin: 0;
                    }
                    
                    .retry-btn {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        background: #3b82f6;
                        color: #fff;
                        border: none;
                        border-radius: 8px;
                        padding: 8px 16px;
                        font-size: 0.875rem;
                        cursor: pointer;
                        transition: background 0.3s ease;
                        
                        &:hover {
                            background: #2563eb;
                        }
                    }
                }
            }
            
            .error-container {
                color: #ef4444;
                
                p {
                    color: #ef4444;
                }
            }
        }
        
        .pagination-section {
            padding: 24px 32px;
            text-align: center;
            border-top: 1px solid #e2e8f0;
            background: #fafbfc;
            
            .load-more-btn {
                background: #374151;
                color: #fff;
                border: none;
                border-radius: 12px;
                padding: 12px 24px;
                font-size: 0.95rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 0 auto;
                
                &:hover:not(:disabled) {
                    background: #1f2937;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
                
                &:disabled {
                    background: #9ca3af;
                    cursor: not-allowed;
                    transform: none;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
            }
        }
    }
    
    
    @media (max-width: 768px) {
        padding: 16px 0;
        height: calc(100vh - 32px);
        
        .tab-navigation {
            margin: 0 8px 16px 8px;
            
            .tab-buttons {
                .tab-btn {
                    padding: 10px 16px;
                    font-size: 0.875rem;
                    
                    .count {
                        padding: 1px 6px;
                        font-size: 0.7rem;
                    }
                }
            }
        }
        
        .header-row {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
            margin-bottom: 16px;
            flex-shrink: 0;
            
            .create-btn {
                align-self: flex-end;
            }
        }
        
        .card {
            margin: 0 8px;
            padding: 20px;
            border-radius: 16px;
            
            .packages-table {
                font-size: 0.875rem;
                
                th, td {
                    padding: 12px 8px;
                }
                
                .package-info {
                    .package-title {
                        font-size: 0.9rem;
                    }
                    
                    .package-desc {
                        display: none;
                    }
                }
                
                .actions {
                    .action-btn {
                        width: 32px;
                        height: 32px;
                    }
                }
            }
            
            .pagination-section {
                padding: 16px 20px;
                
                .load-more-btn {
                    width: 100%;
                    justify-content: center;
                    font-size: 0.875rem;
                    padding: 10px 20px;
                }
            }
        }
    }
}
</style>
